import { Link } from "react-router-dom";
import SectionHeading from "@/components/base/SectionHeading";
import DramaCard from "@/components/base/DramaCard";
import { relatedDramas } from "@/mocks/related";

export default function RelatedSpotlight() {
  return (
    <section className="w-full px-4 md:px-8 py-10 md:py-14">
      <SectionHeading
        eyebrow="精选推荐"
        title="你可能也喜欢"
        desc="与《善良的小姨子》题材风格相近的家庭情感与治愈系剧集。"
        action={
          <Link
            to="/related"
            className="inline-flex items-center gap-1 text-sm text-primary-600 hover:text-primary-700 cursor-pointer whitespace-nowrap w-fit"
          >
            查看全部推荐 <i className="ri-arrow-right-line"></i>
          </Link>
        }
      />

      <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-3 md:gap-5">
        {relatedDramas.map((item) => (
          <DramaCard
            key={item.id}
            to="/related"
            cover={item.cover}
            title={item.title}
            genre={item.genre}
            year={item.year}
            rating={item.rating}
            summary={item.summary}
          />
        ))}
      </div>
    </section>
  );
}